// important for intercom
export const setUserId = (userId) => {
  localStorage.setItem('user_id', userId);
};

export const setName = (name) => {
  localStorage.setItem('name', name);
};
export const setIsInit = (bool) => {
  localStorage.setItem('isInit', bool);
};

export const setUserName = (username) => {
  localStorage.setItem('username', username);
};

export const setEmail = (email) => {
  localStorage.setItem('email', email);
};

export const setOrderTutorId = (tutor_id) => {
  localStorage.setItem('tutor_id', tutor_id);
};

export const setMobile = (mobile_number, phoneCode) => {
  localStorage.setItem('mobile_number', `${phoneCode}${mobile_number}`);
};

export const setPhone = (mobile_number, phoneCode) => {
  localStorage.setItem('phone', `${phoneCode}${mobile_number}`);
};

export const setUserTypeIntercom = (type) => {
  localStorage.setItem('UserType', type);
};

// end intercom

export const setToken = (token) => {
  return localStorage.setItem('token', token);
};

export const setIsNew = (isNew) => {
  return localStorage.setItem('isNew', isNew);
};

export const setProfileComplete = (isComplete) => {
  return localStorage.setItem('isComplete', isComplete);
};

export const getUserId = () => {
  return localStorage.getItem('user_id');
};

export const getOrderTutorId = () => {
  return localStorage.getItem('tutor_id');
};

export const setIsVerified = (isVerified) => {
  return localStorage.setItem('isVerified', isVerified);
};
export const getIsNew = () => {
  return localStorage.getItem('isNew');
};

export const getProfileComplete = () => {
  return localStorage.getItem('isComplete');
};

export const getIsVerified = () => {
  return localStorage.getItem('isVerified');
};

export const getToken = () => {
  return localStorage.getItem('token');
};

// temporarily

export const setUserType = (type) => {
  localStorage.setItem('user_type', type);
};

export const getUserType = () => {
  return localStorage.getItem('user_type');
};

export const checkIsInit = () => {
  return localStorage.getItem('isInit');
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
